import React from 'react'
import styled from 'styled-components'
import { Loader, Dimmer } from 'semantic-ui-react'
import PropTypes from 'prop-types'

import ImagePreview from './ImagePreview'
import PDFPreview from './PDFPreview'

const getComponent = (ext, previewProps) => {
  switch (ext) {
    case 'jpg':
    case 'image/jpg':
      return <ImagePreview previewProps={previewProps} />

    case 'pdf':
    case 'application/pdf':
      return <PDFPreview previewProps={previewProps} />

    default:
      return null
  }
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 620px;
  overflow: hidden;

  @media (max-height: 768px) {
    height: 510px;
  }

  .file-preview__image {
    max-height: 100%;
    max-width: 100%;
  }

  .file-preview__pdf {
    width: 100%;
    height: 100%;
    border: 0px none;
  }
`

const FilePreview = ({ isFetching, type, previewProps }) => {
  const Component = getComponent(type, previewProps)

  return (
    <Wrapper>
      {isFetching ? (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      ) : (
        Component
      )}
    </Wrapper>
  )
}

FilePreview.propTypes = {
  previewProps: PropTypes.object,
  type: PropTypes.string,
}

FilePreview.defaultProps = {
  type: '',
}

export default FilePreview
